import _slicedToArray from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-3/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Field } from "redux-form";
import { required } from '@defi/core-utils';
const MASKED_STRING = "*****";
const MaskingWrapper = props => {
  const col = props.col,
    component = props.component,
    editStatus = props.editStatus,
    context = props.context,
    name = props.name,
    isRequired = props.isRequired,
    value = props.value,
    isActive = props.isActive;
  let mode = col.get('MaskingMode');
  if (mode !== 0) {
    const _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      setClick = _useState2[1];
    let title = col.get('MaskingMode') === 1 ? "Click to unmask" : '';
    let elemtValue = value || col.get('Value');
    const renderBlankField = prop => {
      const name = prop.input.name,
        _prop$meta = prop.meta,
        touched = _prop$meta.touched,
        error = _prop$meta.error;
      const showError = touched && error;
      return showError ? component({
        name,
        error,
        value: ""
      }) : component({
        name,
        error: "",
        value: ""
      });
    };
    if (elemtValue !== "") {
      if ((mode === 1 || mode === 2) && !clicked) {
        const style = {
          cursor: mode === 1 ? 'pointer' : 'auto',
          pointerEvents: 'auto'
        };
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: title,
          placement: "right",
          onClick: () => {
            if (mode !== 2) setClick(true);
          }
        }, component ? component({
          name: "",
          error: "",
          value: MASKED_STRING,
          style
        }) : /*#__PURE__*/React.createElement("span", null, MASKED_STRING));
      }
    } else if (mode === 2 && editStatus) {
      const elementId = String(col.get('ElementId'));
      const fieldName = name || String('de-' + col.get('DataElement').get('Id'));
      return isActive ? /*#__PURE__*/React.createElement(Field, {
        id: elementId,
        name: fieldName,
        component: renderBlankField,
        context: context,
        validate: isRequired ? [required] : []
      }) : null;
    }
  }
  return props.children;
};
MaskingWrapper.defaultProps = {
  editStatus: false
};
export default MaskingWrapper;